import { useEffect } from 'react';

/**
 * The Backend pushes `DsiTriggersChanged` (SignalR) when a chart write made a new decision support
 * intervention fire. The census hub turns it into this window event, so the components showing
 * triggers for that patient re-read them without importing the hub or the store.
 */
export const DSI_TRIGGERS_CHANGED_EVENT = 'memry:dsi-triggers-changed';

export const notifyDsiTriggersChanged = (patientId: number) => {
    window.dispatchEvent(new CustomEvent<{ patientId: number }>(DSI_TRIGGERS_CHANGED_EVENT, { detail: { patientId } }));
};

/** Calls `onChanged` whenever the Backend reports new triggers for `patientId`. */
export const useDsiTriggersChanged = (patientId: number | null | undefined, onChanged: () => void) => {
    useEffect(() => {
        if (!patientId) {
            return undefined;
        }

        const listener = (event: Event) => {
            if ((event as CustomEvent<{ patientId?: number }>).detail?.patientId === patientId) {
                onChanged();
            }
        };

        window.addEventListener(DSI_TRIGGERS_CHANGED_EVENT, listener);

        return () => window.removeEventListener(DSI_TRIGGERS_CHANGED_EVENT, listener);
        // The callback is expected to be a state setter or equivalent; re-subscribing on every render is not needed.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [patientId]);
};
